"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useImgLiteStyles = void 0;
var react_1 = require("react");
if (globalThis.document) {
    var styleElement = globalThis.document.createElement('style');
    styleElement.innerHTML = "\n      @keyframes imglite_bg_pulse {\n        0% { background-color: rgba(0, 0, 0, 0.1) }\n        50% { background-color: rgba(0, 0, 0, 0.2) }\n        100% { background-color: rgba(0, 0, 0, 0.1) }\n      }";
    globalThis.document.head.prepend(styleElement);
}
var getRandomId = function () {
    return Math.random().toString(36).substr(2);
};
var isEmpty = function (dimension) {
    return dimension === undefined || dimension === null || dimension === '';
};
var useImgLiteStyles = function (_a) {
    var children = _a.children, height = _a.height, isPrintable = _a.isPrintable, liteSrc = _a.liteSrc, pulseBackground = _a.pulseBackground, width = _a.width;
    var uniqueId = (0, react_1.useMemo)(function () { return "imglite_".concat(getRandomId()); }, []);
    var hasChildren = !!children;
    (0, react_1.useEffect)(function () {
        var _a, _b;
        var baseSelector = "[data-imglite-id=".concat(uniqueId, "]");
        var visibilitySelector = "[data-imglite-visible=true]";
        var styles = "\n    ".concat(baseSelector, " {\n      -webkit-print-color-adjust: ").concat(isPrintable ? 'exact' : 'economy', ";\n      color-adjust: ").concat(isPrintable ? 'exact' : 'economy', ";\n      display: ").concat(hasChildren ? 'flex' : 'inline-block', ";\n      background-position: center center;\n      background-repeat: no-repeat;\n      background-size: cover;\n      transition: background 0ms;\n      width: ").concat(isEmpty(width) ? 'auto' : width, ";\n      height: ").concat(isEmpty(height) ? 'auto' : height, ";\n      ").concat(pulseBackground ? "background-color: rgba(0, 0, 0, 0.1);" : '', " \n      ").concat(pulseBackground ? "animation: imglite_bg_pulse 1.5s infinite;" : '', " \n    }\n    \n    ").concat(baseSelector).concat(visibilitySelector, " {\n      background-image: url('").concat(liteSrc, "');\n    }\n    ");
        var styleElement = (_a = globalThis.document) === null || _a === void 0 ? void 0 : _a.createElement('style');
        if (!styleElement)
            return;
        styleElement.setAttribute('data-imglite', 'true');
        styleElement.innerHTML = styles;
        (_b = globalThis.document.head) === null || _b === void 0 ? void 0 : _b.prepend(styleElement);
        return function () {
            var _a;
            (_a = globalThis.document.head) === null || _a === void 0 ? void 0 : _a.removeChild(styleElement);
        };
    }, [hasChildren, height, isPrintable, liteSrc, pulseBackground, uniqueId, width]);
    return uniqueId;
};
exports.useImgLiteStyles = useImgLiteStyles;
